export const recipientMessagesCompanyDefaultColumns = [
  { label: 'Status', value: 'status' },
  { label: 'Método', value: 'method' },
  { label: 'Empresa', value: 'company' },
  { label: 'Assunto', value: 'subject' },
  { label: 'Data e hora de envio', value: 'sent_at' },
];
